module.exports = __webpack_public_path__ + "media/images/layout/custom_icon-d6678d8768c28661a1c9691e11798cef.svg";